import React from "react";
import {APIURL} from "./../../../Constantes";
import {LProveedoresStyle} from "./style";
const LogoProveedor = ({idProveedor, titulo, full=false}) =>{
    const classes = LProveedoresStyle();
    return(
        <img  className={(full) ? classes.imgFull : classes.imgContainer} src={`${APIURL}/Supplier/${idProveedor}/Logo`} alt={titulo} />
    )
}
export default LogoProveedor;